import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';
// Type extensions are imported here so they are available throughout the whole application
import './app/helpers/typeExtensions';

if (environment.environment === 'production' || environment.environment === 'release') {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
